/* import React, { useEffect, useState } from "react";
import { useAuth } from "../../Utility/AuthProvider";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import CircularInitial from "./CircularInitial";
import OverdueStatus from "../Reports/components/OverdueStatus";

const ReusableComponent = ({ name, address, amount, status }) => {
  const { jwt } = useAuth();
  const [rentData, setRentData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await APICall(
          "GET",
          paths.rent.overview,
          undefined,
          undefined,
          jwt
        );
        const rentDataFromResponse = response?.response?.rent_data || [];
        setRentData(rentDataFromResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [jwt]); // Run effect when jwt changes

  console.log("Upcoming Rent -", rentData);

  return (
    <div className="rounded-lg p-4" style={{ backgroundColor: "white" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {rentData.map((rentalData, index) => (
          <div key={index} className="hover:shadow-lg rounded-md px-4">
            {rentalData.data.slice(0, 1).map((rental, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  marginBottom: "10px",
                  marginTop: "10px",
                  alignItems: "center",
                }}
                className="text-xs"
              >
                <CircularInitial
                  firstName={rental.first_name}
                  lastName={rental.last_name}
                />
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    marginLeft: "10px",
                    justifyContent: "space-between",
                    textAlign: "left",
                  }}
                >
                  <div>
                    {rental.first_name} {rental.last_name}
                    <div className="flex justify-start items-center gap-2">
                      <p className="text-xs">{rental.building_name}</p>
                      <p className="text-xs">{rental.unit_name}</p>
                    </div>
                  </div>

                  <div>
                    <p>{rental.local_amount}</p>
                    <span className="text-xs">
                      {rental.due_in && <p className="text-red-500">Overdue</p>}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReusableComponent;
 */

import React, { useMemo } from "react";
// import { useReportsData } from "../contexts/ReportsContext"; // 🔥 IMPORT the context hook
import {
  useReportsData,
  useUpdateReportsData,
  Loading,
  formatAmount,
  debugAmountValues,
  debugSelectedTenant,
} from "../../Contexts/ReportsContext";
import CircularInitial from "./CircularInitial";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/animations/loader.json";

// The component is now much simpler and focused on rendering data.
const ReusableComponent = () => {
  // 🔥 CONSUME data and loading state directly from the ReportsContext.
  // No more local state or useEffect for data fetching.
  const { rentData, isLoading } = useReportsData();

  // 🔥 PROCESS the data from the context to fit this component's needs.
  // useMemo ensures this logic only runs when the source data (rentData) changes.
  const upcomingRentItems = useMemo(() => {
    // Guard against initial null/undefined data
    if (!rentData || !rentData.all) {
      return [];
    }

    // 1. The context provides data in sections (e.g., grouped by month).
    //    We flatten it into a single list of all rental items.
    const allItems = rentData.all.flatMap((section) => section.data);

    // 2. Filter for items that are marked as upcoming or overdue,
    //    replicating the logic from the original component.
    const dueItems = allItems.filter((item) => item.due_in);

    // 3. Limit the list to a maximum of 5 items for the dashboard view.
    return dueItems.slice(0, 5);
  }, [rentData]); // This dependency array ensures the list is re-calculated when rentData updates.

  return (
    <div className="w-full">
      {/* Use the isLoading state from the context */}
      {isLoading && upcomingRentItems.length === 0 ? ( // Show loader only on initial load
        <div className="flex justify-center items-center py-4">
          <Lottie
            animationData={loaderAnimation}
            loop={true}
            className="w-20 h-20"
          />
        </div>
      ) : upcomingRentItems.length > 0 ? (
        <div className="space-y-3">
          {upcomingRentItems.map((rental, index) => (
            <div
              key={rental.entity_id || index}
              className="flex items-center p-3 border border-gray-200 rounded-md hover:shadow-sm transition-shadow"
            >
              <CircularInitial
                firstName={rental.first_name}
                lastName={rental.last_name}
              />
              <div className="flex flex-grow justify-between items-center ml-3 text-xs md:text-sm">
                <div>
                  <p className="font-medium text-gray-800">
                    {rental.first_name} {rental.last_name}
                  </p>
                  <div className="flex items-center gap-1 text-gray-500 text-xs">
                    <span>{rental.building_name}</span>
                    <span>/</span>
                    <span>{rental.unit_name}</span>
                  </div>
                </div>

                <div className="text-right">
                  <p className="font-semibold text-gray-800">
                    {typeof rental.local_amount === "number"
                      ? rental.local_amount.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 0,
                        })
                      : rental.local_amount}
                  </p>
                  {rental.due_in && (
                    <span className="text-xs font-medium text-red-600">
                      Overdue
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-500 py-4">
          No upcoming rent found.
        </div>
      )}
    </div>
  );
};

export default ReusableComponent;
